import React, { useMemo } from 'react';
import { APITypes } from '../../../../primary-record-types';
import useMedicalProfiles from '../../../../hooks/api/useMedicalProfiles';
import useOrganizationMedicalProfiles from '../../../../hooks/api/useOrganizationMedicalProfiles';
import { useUserType } from '../../../../hooks/api/useUser';

export type Profile =
    | APITypes.medicalProfileService.ProfileListItem
    | APITypes.organizationService.OrganizationMedicalProfileDetails;

export type ProfilesProviderChildren = (isLoading: boolean, profiles: Profile[]) => React.ReactNode;

export type ProfilesProviderOwnProps = {
    children: ProfilesProviderChildren;
};

const ConsumerProfilesProvider: React.FC<ProfilesProviderOwnProps> = (props) => {
    const { collaboratorMedicalProfiles, medicalProfiles, isLoadingProfiles } = useMedicalProfiles();
    const allProfiles = useMemo(
        () => [...medicalProfiles, ...collaboratorMedicalProfiles],
        [collaboratorMedicalProfiles, medicalProfiles],
    );

    return <>{props.children(isLoadingProfiles, allProfiles)}</>;
};

const ProProfilesProvider: React.FC<ProfilesProviderOwnProps> = (props) => {
    const { isLoadingOrganizationMedicalProfiles, organizationMedicalProfiles } = useOrganizationMedicalProfiles();
    return <>{props.children(isLoadingOrganizationMedicalProfiles, organizationMedicalProfiles)}</>;
};

export type ProfilesProviderProps = ProfilesProviderOwnProps;

const ProfilesProvider: React.FC<ProfilesProviderProps> = (props) => {
    const userType = useUserType();
    return userType === 'consumer' ? <ConsumerProfilesProvider {...props} /> : <ProProfilesProvider {...props} />;
};

export default React.memo(ProfilesProvider);
